/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Party_Label_One_AdultInputs */

const en_party_label_one_adult = /** @type {(inputs: Party_Label_One_AdultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 adult`)
};

/**
* | output |
* | --- |
* | "1 adult" |
*
* @param {Party_Label_One_AdultInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const party_label_one_adult = /** @type {((inputs?: Party_Label_One_AdultInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Party_Label_One_AdultInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_party_label_one_adult(inputs)
});